import React, { useState } from 'react';
import axios from 'axios';
import './EmailUpdateForm.css';

const EmailUpdateForm = ({ currentEmail = '', apiEndpoint = 'https://dseapi.sadhanlab.com/api/profile/email/' }) => {
  const [email, setEmail] = useState(currentEmail);
  const [status, setStatus] = useState({ type: null, message: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setIsSubmitting(true);
//     setStatus({ type: null, message: '' });

//     try {
//       const token = localStorage.getItem('authToken'); 
//       const response = await axios.patch(
//         apiEndpoint,
//         { email: email },
//         {
//           headers: {
//             'Authorization': `Token ${token}`,
//             'Content-Type': 'application/json',
//           },
//         }
//       );

//       setStatus({
//         type: 'success',
//         message: 'Email updated successfully!',
//       });
//       setEmail(response.data.email || '');
//     } catch (err) {
//       const errorMsg =
//         err.response?.data?.email?.[0] ||
//         err.response?.data?.detail ||
//         'Failed to update email. Please try again.';

//       setStatus({
//         type: 'error',
//         message: errorMsg,
//       });
//     } finally {
//       setIsSubmitting(false);
//     }
//   };



const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setStatus({ type: null, message: '' });

    try {
      // 1. Fetch token using the exact key saved in App.js ("token")
      const token = localStorage.getItem('token'); 

      if (!token) {
        setStatus({
          type: 'error',
          message: 'You are not logged in. Please log in again.',
        });
        setIsSubmitting(false);
        return;
      }

      // 2. Pass standard DRF Authorization header
      const response = await axios.patch(
        apiEndpoint,
        { email: email },
        {
          headers: {
            'Authorization': `Token ${token}`, // Use `Bearer ${token}` if using JWT
            'Content-Type': 'application/json',
          },
        }
      );

      setStatus({
        type: 'success',
        message: 'Email updated successfully!',
      });
      setEmail(response.data.email || '');
    } catch (err) {
      const errorMsg =
        err.response?.data?.email?.[0] ||
        err.response?.data?.detail ||
        'Failed to update email. Please try again.';

      setStatus({
        type: 'error',
        message: errorMsg,
      });
    } finally {
      setIsSubmitting(false);
    }
  };



  return (
    <div className="email-card">
      <h2 className="email-card-title">Update Email Address</h2>
      
      {status.message && (
        <div className={`status-alert status-${status.type}`}>
          {status.message}
        </div>
      )}

      <form onSubmit={handleSubmit} className="email-form">
        <div className="form-group">
          <label htmlFor="email-input">Email</label>
          <input
            id="email-input"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="name@example.com"
            disabled={isSubmitting}
          />
        </div>

        <button 
          type="submit" 
          className="submit-btn" 
          disabled={isSubmitting}
        >
          {isSubmitting ? 'Saving...' : 'Save Changes'}
        </button>
      </form>
    </div>
  );
};

export default EmailUpdateForm;